import { render, staticRenderFns } from "./CardTemplate.vue?vue&type=template&id=38348c79&"
import script from "./CardTemplate.vue?vue&type=script&lang=js&"
export * from "./CardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports